// extracted by mini-css-extract-plugin
var _1 = "DocFlowEpostValidationPreviewImage-moduleDocFlowEpostValidationPreviewImage__ig7ET";
var _2 = "DocFlowEpostValidationPreviewImage-moduledownloadButton__oPuwZ";
var _3 = "DocFlowEpostValidationPreviewImage-moduleheader__aL1DD";
var _4 = "DocFlowEpostValidationPreviewImage-moduleimage__gHK9P";
export { _1 as "DocFlowEpostValidationPreviewImage", _2 as "downloadButton", _3 as "header", _4 as "image" }
